import BasicService from "../service/BasicService";

class DeliveryStatementService extends BasicService {
  constructor() {
    super();
  }

  getDeliveryStatement(fromDate, toDate, userAccountId) {
    let url = "/report/deliveryStatement";
    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate,
          userAccountId
        }
      })
      .then(response => response.data);
  }
}

const deliveryStatementService = new DeliveryStatementService();
export default deliveryStatementService;
